import { render, staticRenderFns } from "./Klaviyo.vue?vue&type=template&id=770cbdde&"
import script from "./Klaviyo.vue?vue&type=script&lang=js&"
export * from "./Klaviyo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports